import { QueryKeys } from '~/hooks/reactQuery/queryKeys';
import { ContactRole } from '~/models/ContactModel';
import { Accounting } from '~/types/accounting';
export function buildCustomerIdToDisplay(customers) {
    return customers.reduce((acc, customer)=>{
        acc[customer.id()] = customer.formattedDisplay();
        return acc;
    }, {});
}
function mappingFor(contact, accounting, customerIdToDisplay) {
    var _customerIdToDisplay_integratedId;
    const integratedId = contact.integratedId({
        accounting
    });
    return {
        accounting,
        display: integratedId != null ? (_customerIdToDisplay_integratedId = customerIdToDisplay[integratedId]) !== null && _customerIdToDisplay_integratedId !== void 0 ? _customerIdToDisplay_integratedId : null : null
    };
}
export function toMappingsByContactId(contacts, maps) {
    return contacts.reduce((acc, contact)=>{
        acc[contact.id()] = toContactMappings(contact, maps);
        return acc;
    }, {});
}
function toContactMappings(contact, maps) {
    const mappings = [];
    if (maps.showQbo) mappings.push(mappingFor(contact, Accounting.QBO, maps.qboCustomerIdToDisplay));
    if (maps.showXero) mappings.push(mappingFor(contact, Accounting.Xero, maps.xeroCustomerIdToDisplay));
    return mappings;
}
export const lastOwnerCandidateUserId = (contact)=>contact.role() === ContactRole.Owner ? contact.userId() : null;
export const isLastOwnerQueryKey = (userId, clientId)=>[
        QueryKeys.IsLastOwner,
        userId,
        clientId
    ];
